/**
 * CAPTION IT — Quick Configurator (3-step inline widget)
 *
 * v2: + slider tono cambia le carte preview (educato/spinto/serio)
 *     + checkout reale (cart/add.js con variant + properties)
 */
(function () {
  'use strict';

  /* Set di template carte preview per ogni tone range */
  const TEMPLATES_BY_TONE = {
    // educato (tone < 35): leggero, ironico, family-friendly
    educato: [
      'Quando {name} lascia il telefono in carica tre ore ma non lo attacca alla presa',
      'Quando {name} dice "nel caso vi raggiungo dopo" sapendo già che non lo farà mai',
      'Quando {name} fa conoscere due amici e quei due iniziano ad uscire senza di lui/lei',
    ],
    // spinto (tone 35-75): dark, irriverente
    spinto: [
      'Quando {name} l\'ha appena spuntata in una discussione WhatsApp e vede apparire "sta scrivendo"',
      'Quando {name} all\'ennesimo mojito inizia a parlarti dei suoi traumi infantili pesanti',
      'Quando {name} affronta le responsabilità con la faccia di chi non gliene frega un cazzo',
    ],
    // serio (tone > 75): no-filter, sopra le righe
    serio: [
      'Quando {name} stava per venire ma la trama del porno si è infittita',
      'Quando {name} dice "stiamo solo amici" alla sesta dopo-cena',
      'Quando {name} riscrive all\'ex mentre giura di averla superata definitivamente',
    ],
  };

  function templateSetForTone(tone) {
    if (tone < 35) return TEMPLATES_BY_TONE.educato;
    if (tone < 75) return TEMPLATES_BY_TONE.spinto;
    return TEMPLATES_BY_TONE.serio;
  }

  class Configurator {
    constructor(el) {
      this.el = el;
      this.step = 1;
      this.totalSteps = 3;
      this.data = {
        name: el.dataset.sampleName || 'MARCO',
        occasion: 'laurea',
        tone: 65,
        pkg: 'MEDIUM',
        variantId: null,
      };

      this.stepPanels = el.querySelectorAll('[data-step]');
      this.stepTabs   = el.querySelectorAll('[data-tab]');
      this.nextBtn      = el.querySelector('[data-next]');
      this.prevBtn      = el.querySelector('[data-prev]');
      this.checkoutCta  = el.querySelector('[data-checkout-cta]');
      this.navTimer     = el.querySelector('[data-nav-timer]');
      this.nameInput  = el.querySelector('[data-name-input]');
      this.chips      = el.querySelectorAll('[data-occasion]');
      this.slider     = el.querySelector('[data-tone]');
      this.sliderFill = el.querySelector('[data-tone-fill]');
      this.sliderThumb= el.querySelector('[data-tone-thumb]');
      this.cardTexts  = el.querySelectorAll('[data-card-text]');
      this.pkgRadios  = el.querySelectorAll('input[name="pkg"]');

      this.bind();
      this.render();
      this.updateCards(); // boot: prima volta
    }

    bind() {
      this.nextBtn?.addEventListener('click', () => this.go(this.step + 1));
      this.checkoutCta?.addEventListener('click', () => this.goToCheckout());
      this.prevBtn?.addEventListener('click', () => this.go(this.step - 1));

      this.stepTabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const n = parseInt(tab.dataset.tab, 10);
          if (!isNaN(n)) this.go(n);
        });
      });

      this.nameInput?.addEventListener('input', (e) => {
        this.data.name = (e.target.value || 'MARCO').toUpperCase();
        this.updateCards();
      });
      this.nameInput?.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') { e.preventDefault(); e.target.blur(); }
      });

      this.chips.forEach((chip) => {
        chip.addEventListener('click', () => {
          this.data.occasion = chip.dataset.occasion;
          this.chips.forEach((c) => {
            const active = c === chip;
            c.classList.toggle('ci-chip--active', active);
            c.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        });
        chip.setAttribute('aria-pressed', chip.classList.contains('ci-chip--active') ? 'true' : 'false');
      });

      if (this.slider) {
        this.slider.setAttribute('aria-valuemin', '0');
        this.slider.setAttribute('aria-valuemax', '100');
        this.slider.setAttribute('aria-valuenow', String(this.data.tone));
        const onSlide = (e) => {
          this.data.tone = parseInt(e.target.value, 10);
          this.updateSliderUI();
          this.updateCards(); // ★ NUOVO: aggiorna carte quando slider si muove
          this.slider.setAttribute('aria-valuenow', String(this.data.tone));
        };
        this.slider.addEventListener('input', onSlide);
        this.slider.addEventListener('change', onSlide);
        this.updateSliderUI();
      }

      // Pacchetti radio: traccia variant ID + pkg label
      this.pkgRadios.forEach((r) => {
        r.addEventListener('change', () => {
          if (r.checked) {
            this.data.pkg = r.value;
            this.data.variantId = r.dataset.variantId || null;
          }
        });
        // Init: se è checked, salva variant
        if (r.checked) {
          this.data.pkg = r.value;
          this.data.variantId = r.dataset.variantId || null;
        }
      });
    }

    go(step) {
      if (step < 1 || step > this.totalSteps) return;
      this.step = step;
      this.render();
    }

    render() {
      this.stepPanels.forEach((p) => {
        const active = parseInt(p.dataset.step, 10) === this.step;
        p.hidden = !active;
      });
      this.stepTabs.forEach((t) => {
        const active = parseInt(t.dataset.tab, 10) === this.step;
        t.classList.toggle('ci-steps-tab--active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (this.prevBtn) {
        const atStart = this.step === 1;
        this.prevBtn.style.opacity = atStart ? '0.4' : '1';
        this.prevBtn.disabled = atStart;
        this.prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      }
      const isLast = this.step === this.totalSteps;
      if (this.checkoutCta) {
        // Se esiste il bottone CTA dedicato, usa quello all'ultimo step
        this.nextBtn.hidden = isLast;
        this.checkoutCta.hidden = !isLast;
        if (this.navTimer) this.navTimer.hidden = isLast;
      } else if (this.nextBtn) {
        // Fallback: cambia solo il testo del nextBtn
        this.nextBtn.textContent = isLast ? 'vai al checkout →' : 'prossimo →';
      }
    }

    updateCards() {
      const set = templateSetForTone(this.data.tone);
      this.cardTexts.forEach((el, i) => {
        const tpl = set[i] || set[0];
        el.textContent = tpl.replace(/{name}/g, this.data.name);
      });
    }

    updateSliderUI() {
      const pct = this.data.tone + '%';
      if (this.sliderFill)  this.sliderFill.style.width = pct;
      if (this.sliderThumb) this.sliderThumb.style.left = pct;
      /* Label attivo (educato / spinto / serio) — match con templateSetForTone */
      const activeLabel = this.data.tone < 35 ? 'educato'
                        : this.data.tone < 75 ? 'spinto'
                        : 'serio';
      this.el.querySelectorAll('[data-tone-label]').forEach((span) => {
        const isActive = span.dataset.toneLabel === activeLabel;
        span.classList.toggle('ci-slider-label--active', isActive);
        /* Prefix bullet "● " sull'attivo (rimosso dagli altri) */
        const base = span.dataset.toneLabelBase
          || (span.dataset.toneLabelBase = span.textContent.replace(/^●\s*/, ''));
        span.textContent = isActive ? '● ' + base : base;
      });
    }

    /* Checkout reale: addToCart Shopify con line item properties */
    async goToCheckout() {
      if (!this.data.variantId) {
        alert('Nessuna variante prodotto disponibile. Configurare il prodotto nelle impostazioni della section.');
        return;
      }
      const activeBtn = this.checkoutCta || this.nextBtn;
      activeBtn.disabled = true;
      activeBtn.textContent = 'aggiungo al carrello…';

      // Mapping tone slider 0-100 → vibe del briefing v4 (irriverente/chaos/spicy)
      let vibe = 'irriverente';
      if (this.data.tone >= 75) vibe = 'spicy';
      else if (this.data.tone >= 50) vibe = 'chaos';

      const properties = {
        Festeggiato: this.data.name,
        Occasione: this.data.occasion,
        Vibe: vibe,
        Tono: String(this.data.tone),
        Pacchetto: this.data.pkg,
      };

      try {
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: this.data.variantId, quantity: 1, properties }),
        });
        if (!r.ok) {
          const errData = await r.json().catch(() => ({}));
          alert('Errore: ' + (errData.description || r.status));
          activeBtn.disabled = false;
          activeBtn.textContent = 'aggiungi al carrello →';
          return;
        }
        window.location.href = '/cart';
      } catch (e) {
        alert('Errore di rete: ' + (e?.message || ''));
        activeBtn.disabled = false;
        activeBtn.textContent = 'aggiungi al carrello →';
      }
    }
  }

  function init() {
    document.querySelectorAll('[data-ci-configurator]').forEach((el) => new Configurator(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
